import { TrackingApi } from 'api/TrackingApi';
import { WebpushApi, WebpushErrorTypes } from 'api/WebpushApi';

import { firebaseGetToken, getFbTokenFromLocalStorage } from './firebase';
import {
  getWebpushApiData,
  isNotificationsPermissionsGranted,
  isWebPushesEnabledByPartners,
  isWebPushesEnabledBySite,
  requestPushPermissions,
  setPushPermissionsAskedFlag,
  shouldRequestPermissionOnStartup,
  shouldRequestPermissions,
} from './webpush';

export const FirebaseNotificationManager = {
  showSubscriptionPrompt() {
    WebpushApi.trackShow();

    setPushPermissionsAskedFlag();

    requestPushPermissions({
      onDefault: this.closeSubscriptionPopupHandler,
      onDenied: this.declineSubscriptionPromptHandler,
      onGranted: this.acceptSubscriptionPromptHandler,
    });
  },

  requestPushPermissionsOnStartupAndTrack() {
    if (!shouldRequestPermissionOnStartup(document.location.pathname)) return;

    this.requestPushPermissionsAndTrack();
  },

  requestPushPermissionsAndTrack() {
    if (
      isNotificationsPermissionsGranted() ||
      !isWebPushesEnabledBySite() ||
      !isWebPushesEnabledByPartners(document.location.search)
    )
      return;

    if (!shouldRequestPermissions()) {
      WebpushApi.trackError({
        message: 'Request permissions error',
        webpushesApiData: getWebpushApiData(),
        operation: WebpushErrorTypes.ShowPopupError,
      });

      return;
    }

    this.showSubscriptionPrompt();
  },

  closeSubscriptionPopupHandler() {
    WebpushApi.trackClose();
  },

  declineSubscriptionPromptHandler() {
    WebpushApi.trackDecline();
  },

  async acceptSubscriptionPromptHandler() {
    WebpushApi.trackClickAllow();

    try {
      const token = await firebaseGetToken();

      WebpushApi.subscribe({ token });
    } catch (err) {
      console.error('[acceptSubscriptionPrompt]: ', err);
    }
  },

  async tryToUpdateTokenAndSendItToServer() {
    if (!isNotificationsPermissionsGranted()) {
      return;
    }

    try {
      const newToken = await firebaseGetToken();

      if (getFbTokenFromLocalStorage() === newToken) {
        return;
      }

      TrackingApi.trackError({
        type: 'warning',
        message: `Firebase: try to refresh token `,
      });

      WebpushApi.refreshToken();
    } catch (err) {
      console.error('[tryToUpdateTokenAndSendItToServer]: ', err);
    }
  },
};
